import React from 'react'
import { urlKey } from '../../../services/api/api-urls'
import { getColModelItem, getItemsObj, getRandomKey, renderFn, nbsStr } from '../../../services/lib/utils/helpers'
import moment from 'moment'


export const colKey: any = {
  draft: 'draft',
  quotationNo: 'quotationNo',
  customerId: urlKey.Customer,
  customerCode:  'customerCode',
  effDate: 'effDate',
  expDate: 'expDate',
  employeeId: urlKey.Employee,
}

const keyInfosArray: any = () => {
  return [
    {key: colKey.customerId, label: 'R/A', otherOptions: {required: true, type: 'select', isOverrideSelectionOptions: true, valueJoinArray: ['company']}},
    {key: colKey.customerCode, label: 'T/A'},    
    {key: colKey.quotationNo, label: 'No'},
    {key: colKey.employeeId, label: 'Sales', otherOptions: {type: 'select', isOverrideSelectionOptions: true, valueJoinArray: ['firstName', 'lastName']}},
  ]
}

const colInfos: any = {
  basicInfo: {
    title: 'Basic Info',
    field: 'basicInfo',
    keywords: [colKey.customerId, colKey.customerCode,colKey.employeeId]
  },
  items: {
    title: 'Items Info',
    field: 'items',
  },
  notes: {
    title: 'Notes',
    field: 'notes',
  },
}
const renderCreatedBy = (rowData:any) => {
  let firstName = rowData.operator?.firstName?rowData.operator?.firstName:rowData.employee?.firstName
  return (
    <div style={rowData.isFinal ? { color: 'red', fontWeight: 'bold' } : {}}>
      <b>{rowData.isFinal ? "Contact Price" :firstName}</b>
    </div>
  );
};
const QuotationManagementColumnModel = (isCustomer?:boolean) => {
  return [
    {
      ...getColModelItem(colInfos.basicInfo, keyInfosArray),
      render: (rowData: any) => {
        if (isCustomer) {
          return renderFn(getItemsObj(keyInfosArray(), rowData), [colKey.employeeId, colKey.quotationNo]);
        }
        // 管理端自定义布局：
        // - R/A 过长截断为省略号，悬停显示全文
        // - T/A 正常显示
        // - Sales 去掉 label 直接显示姓名，与 No 同行；No 用高亮徽标突出
        const ra = rowData.customer?.company || ''
        const ta = rowData.customerCode || ''
        const sales = [rowData.employee?.firstName, rowData.employee?.lastName].filter(Boolean).join(' / ')
        const no = rowData.quotationNo || ''
        // label 标签化：小号浅底徽标，替代原来的粗体文字 "R/A:" / "T/A:"
        const labelTag = (text: string) => (
          <span style={{
            display: 'inline-block',
            minWidth: '2.4rem',
            textAlign: 'center',
            padding: '1px 6px',
            marginRight: '6px',
            borderRadius: '4px',
            backgroundColor: '#f0f2f0',
            color: '#4a5d51',
            border: '1px solid #dde4df',
            fontSize: '11px',
            fontWeight: 600,
            lineHeight: '16px',
          }}>
            {text}
          </span>
        )
        return (
          <div>
            <div title={ra} style={{ display: 'flex', alignItems: 'center', maxWidth: '18rem' }}>
              {labelTag('R/A')}
              <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{ra}</span>
            </div>
            {!!ta && (
              <div title={ta} style={{ display: 'flex', alignItems: 'center', marginTop: '2px' }}>
                {labelTag('T/A')}
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{ta}</span>
              </div>
            )}
            {(!!sales || !!no) && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '2px' }}>
                {!!no && (
                  <span style={{
                    fontWeight: 600,
                    color: '#1B3B2E',
                    backgroundColor: '#e8f5ed',
                    border: '1px solid #8BC9A3',
                    padding: '1px 8px',
                    borderRadius: '999px',
                    fontSize: '12px',
                    whiteSpace: 'nowrap',
                  }}>
                    {no}
                  </span>
                )}
                {!!sales && <span>{sales}</span>}
              </div>
            )}
          </div>
        )
      }
    },
    {
      title: 'Quote Date',
      field: 'effDate1',
      render: (rowData: any) => moment.utc(rowData.effDate1).local().format('DD/MM/YY')+"-"+moment.utc(rowData.expDate).local().format('DD/MM/YY'),
    },
    // {
    //   title: 'Valid Date',
    //   field: 'expDate1',
    //   render: (rowData: any) =>  moment.utc(rowData.expDate).local().format('DD/MM/YY'),
    // },
    {
      title: colInfos.items.title,
      field: colInfos.items.field,
      filtering: true,
      editable: 'never',
      render: (rowData:any) => (
        <div>
          {
            rowData.quotationItem.map((row: any) => (
              <div style={{display:'flex'}} key={getRandomKey()}>
                {
                  row.baseProductId ? (
                    <div style={{width:'70ch'}}>
                      <b>B:</b>&nbsp;
                        <span style={{
                          backgroundColor: '#e8f5ed',
                          color: '#1B3B2E',
                          padding: '3px 8px',
                          borderRadius: '4px',
                          fontSize: '13px',
                          fontWeight: 600,
                          border: '1px solid #8BC9A3'
                        }}>
                          {nbsStr(row.baseProduct?.productCode)}
                        </span>
                      <b>&nbsp;</b>{nbsStr(row.baseProduct?.baseProductName,false,48)}
                    </div>
                  ) : null
                }

                {
                  row.productId ? (
                    <div style={{width:'70ch'}}>
                      <b>P:</b>&nbsp;
                          <span style={{
                          backgroundColor: '#e8f5ed',
                          color: '#1B3B2E',
                          padding: '3px 8px',
                          borderRadius: '4px',
                          fontSize: '13px',
                          fontWeight: 600,
                          border: '1px solid #8BC9A3'
                        }}>
                          {nbsStr(row.product?.productCode)}
                        </span>
                      <b>&nbsp;</b>{nbsStr(row.product?.productName,false,48)}
                    </div>
                  ) : null
                }
                <div style={row.isBelowMin ? {color: 'red', fontWeight: 'bold'} : {}}>
                {row.beforeChangePrice && (
                  <s style={{ marginRight: '8px' }}>
                    ${(row.beforeChangePrice ? row.beforeChangePrice : 0).toFixed(2)}
                  </s>
                )}
                  <b>${row.price.toFixed(2)}</b>
                </div>
                {/* <div style={row.isBelowMin ? {color: 'red', fontWeight: 'bold'} : {}}>
                  <b>Below</b>
                </div>                 */}
              </div>
            ))
          }
        </div>
      ),
      customFilterAndSearch: (
        filterValue:any,
        rowData:any
      ) => {
        // console.log(filterValue)
        // console.log(rowData)
        const filter = filterValue.replace(/-/g, '\u2011').trim().slice(0,-1);
        const quotationItems = rowData.quotationItem
        for (const quotationItem of quotationItems) {
          console.log(quotationItem)
          if (quotationItem.product) {
            if (quotationItem.product?.productCode?.replace(/-/g, '\u2011').toUpperCase().includes(filter.toUpperCase())) {
              return true
            }
          }
          if (quotationItem.baseProduct) {
            if (quotationItem.baseProduct?.productCode?.replace(/-/g, '\u2011').toUpperCase().includes(filter.toUpperCase())) {
              return true
            }
          }

        }
        return false
      },
    },
    // {
    //   title: 'Incl Lower Price',
    //   field: 'inclLowerPrice',
    //   lookup: {0: 'No', 1: 'Yes'},
    // },    
    {
      title: 'Created By',
      field: 'employee',
      render: renderCreatedBy
      ,
    },
    // {
    //   title: colInfos.notes.title,
    //   field: colInfos.notes.field,
    //   filtering: false,
    //   editable: 'never',
    //   render: (rowData:any) => (
    //     <div>
    //       {
    //         rowData.quotationOption.map((row: any, index: number) => {
    //
    //           return (
    //             <div key={getRandomKey()}>
    //               {
    //
    //                 row[urlKey.QuotationOptionItem + 'Id'] ? (
    //                   <span>
    //                     <b>#</b>&nbsp;{nbsStr(row[urlKey.QuotationOptionItem]?.[urlKey.QuotationOptionItem + 'Name'])}
    //                   </span>
    //                 ) : (
    //                   <span>
    //                     <b>#</b>&nbsp;{nbsStr(row.customizeOptionNotes)}
    //                   </span>
    //                 )
    //               }
    //             </div>
    //
    //           )
    //         })
    //       }
    //     </div>
    //   ),
    // },
    {
      title: 'Comments',
      field: 'notes',
    },
    // {
    //   title: 'Customer Confirmed',
    //   field: 'custConfirmed',
    //   editable: 'never',
    //   lookup: {0: 'No', 1: 'Yes'},
    //   render: (rowData: any) => rowData.custConfimedAt1
    // },
    {
      title: 'Draft',
      field: colKey.draft,
      defaultSort: 'asc',
      lookup: {0: 'No', 1: 'Yes'}
    }
  ]
}

export default QuotationManagementColumnModel
